import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BookingService } from '../service/booking.service';
import { HttpService } from '../service/http.service';
import { PaymentToSupplierService } from '../service/payment-to-supplier.service';
import { SchoolInvoiceWithPaymentOrders } from '../school-invoice-with-payment-orders';
import { ToastMessageService } from '../toast-message.service';
import { DecimalValidator } from '../validator/decimal-validator';
import { NumberValidator } from '../validator/number-validator';
import Decimal from 'decimal.js';
import { PaymentToSupplier } from '../payment-to-supplier';
import * as moment from 'moment';
import { CurrencyService } from '../service/currency.service';
import { BookingTransactionsService } from '../service/booking-transactions.service';
import { PaymentOrder } from '../payment-order';

@Component({
  selector: 'app-create-payment-to-supplier',
  templateUrl: './create-payment-to-supplier.component.html',
  styleUrls: ['./create-payment-to-supplier.component.css']
})
export class CreatePaymentToSupplierComponent implements OnInit {

  paymentForm!: FormGroup;
  submitFail = false;
  invalidAmount = false;
  paymentOrders: PaymentOrder[] = [];
  invoices: SchoolInvoiceWithPaymentOrders[] = [];
  @Output() newSchoolPaymentEvent = new EventEmitter<any>();
  sendingRequest = false;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    public bookingService: BookingService,
    private toastService: ToastMessageService,
    public paymentToSupplierService: PaymentToSupplierService,
    public currencyService: CurrencyService,
    private bookingTransactionService: BookingTransactionsService
  ) { }

  ngOnInit(): void {
    this.httpService.getSchoolInvoicesWithPaymentOrdersByBookingId(this.bookingService.booking.id!).subscribe(res => {
      for(let invoice of res){
        for(let paymentOrder of invoice.paymentOrders){
          paymentOrder.invoiceNumber = invoice.invoiceNumber;
          paymentOrder.label = paymentOrder.invoiceNumber +  " - " + paymentOrder.amount + " " + paymentOrder.currency.isoCode;
          this.paymentOrders.push(paymentOrder);
        }
      }
    });
    this.paymentForm = this.builder.group({
      paymentOrder: [null, Validators.required],
      amount: [0, Validators.compose([DecimalValidator, NumberValidator])],
      currency: this.currencyService.currencies[0],
      date: [new Date(), Validators.required],
      dueDate: null,
      paymentType: [this.bookingService.paymentTypes[0], Validators.required],
      comment: null
    });
  }

  setPaymentAmount(){
    let selectedOrder = this.paymentForm.get("paymentOrder")!.value;
    this.paymentForm.get("amount")!.setValue(new Decimal(selectedOrder.amount).toFixed(2));
    this.paymentForm.get("currency")!.setValue(selectedOrder.currency);
  }

  amountChange(event: any){
    let value = event.target.value as string;
    if(value.includes(",")){
      value = value.replaceAll(",", ".");
      event.target.value = value;
    }
  }

  submit(){
    this.submitFail = false;
    if(this.paymentForm.invalid){
      this.toastService.addError("Error", "Form is not complated correctly.");
      this.submitFail = true;
      return;
    }
    this.sendingRequest = true;
    let payment = new PaymentToSupplier(
      null,
      moment(this.paymentForm.value.date).utc(true),
      this.paymentForm.value.amount,
      this.paymentForm.value.paymentType, 
      this.paymentForm.value.invoiceNumber,
      this.paymentForm.value.currency,
      this.paymentForm.value.paymentOrder,
      this.paymentForm.value.comment,
      null
    );
    this.httpService.postPaymentToSupplier(payment, this.bookingService.booking.id!, payment.paidOrder.id!).subscribe(() => {
      this.newSchoolPaymentEvent.emit(null);
      this.bookingTransactionService.updateTransactions();
      this.sendingRequest = false;
    }, error => {
      this.toastService.addError("Error", error.error.message);
      this.sendingRequest = false;
    });
  }

}
